import React from 'react';
import PropTypes from 'prop-types';

const CollapseButton = ({ expanded, onToggle, isRight, expandedIcon, collapsedIcon }) => {
    return (
        <button
            type='button'
            aria-label={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
            onClick={onToggle}
            className={`column-sidebar-toggle-button ${expanded ? 'expanded' : 'collapsed'} ${isRight ? 'right' : 'left'}`}
        >
            {expanded ? expandedIcon : collapsedIcon}
        </button>
    );
};

CollapseButton.propTypes = {
    expanded: PropTypes.bool,
    onToggle: PropTypes.func,
    isRight: PropTypes.bool,
    expandedIcon: PropTypes.node,
    collapsedIcon: PropTypes.node,
};

export default CollapseButton;
